import { isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, REQUEST, inject } from '@angular/core';
import { EnvironmentService } from '@pedix-workspace/angular-utils';
import { environment } from '../environments/environment';

@Injectable({ providedIn: 'root' })
export class AppEnvironmentService extends EnvironmentService {
  private platformId = inject(PLATFORM_ID);
  private request = inject(REQUEST, { optional: true });

  constructor() {
    super();

    const devPort = '4200';

    let baseUrl: string;
    let hostname: string;
    
    if (isPlatformServer(this.platformId)) {
      const host = this.request?.headers.get('host') ?? 'localhost';

      baseUrl = `http://${host}`;
      hostname = host.split(':')[0];
    } else {
      baseUrl = location.href;
      hostname = location.hostname;
    }
      
    this.isLocalEnv = new URL(baseUrl).port === devPort;
      
    this.env = environment.production ? 'production' : 'development';
    this.siteUrl = this.isLocalEnv ? 'http://pedix.local:4200' : environment.siteUrl;
    this.isAdminApp = false;
    this.hostname = hostname;
  }
}
